import React from 'react';
import { Container, Content } from './styles';

type LayoutPropTypes = {
  children: React.ReactNode;
  footerProps?: {
    onEndGame(): void;
  };
};

export function Layout({ children }: LayoutPropTypes) {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
}
